<template>
    <div class="modal fade" id="popUpContratto" data-backdrop="true" role="dialog" aria-modal="true">
        <div :class="{'modal-dialog modal-fullscreen': $root.isMobile, 'modal-dialog': !$root.isMobile}" :style="modalStyle">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background: #127787;">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-file-contract fa-fw"></i> Contratto</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" :style="bodyStyle">
                    <!-- Sezione Tipologia Contratto -->
                    <div class="row mt-2 mb-4" style="background-color: rgb(243 243 243);border-radius: 8px;border: 2px dashed rgb(204, 204, 204);margin: 0px;padding: 16px;">
                        <div class="btn-group" style="margin:0 auto;margin-bottom: 20px;" role="group" aria-label="Basic example">
                            <div class="col">
                                <div class="row">
                                    <label style="margin:0 auto">Tipologia Contratto:</label>
                                </div>
                                <div class="row mt-2">
                                    <button style="width:150px;height:60px"
                                        :disabled="(contrattoSelezionato.ID_CONTRATTO > 0 && contrattoSelezionato.FK_ID_TIPO != 0)"
                                        type="button" class="btn btn-lg"
                                        v-bind:class="{ 'btn-secondary': contrattoSelezionato.FK_ID_TIPO == 1, 'btn-light': contrattoSelezionato.FK_ID_TIPO != 1 }"
                                        v-on:click="contrattoSelezionato.FK_ID_TIPO = 1">
                                        <i class="fas" v-bind:class="{ 'fa-lightbulb-on text-warning': contrattoSelezionato.FK_ID_TIPO == 1, 'fa-lightbulb': contrattoSelezionato.FK_ID_TIPO != 1 }"></i>
                                        LUCE
                                    </button>
                                    <button style="width:150px;height:60px"
                                        :disabled="(contrattoSelezionato.ID_CONTRATTO > 0 && contrattoSelezionato.FK_ID_TIPO != 0)"
                                        type="button" class="btn btn-lg"
                                        v-bind:class="{ 'btn-secondary': contrattoSelezionato.FK_ID_TIPO == 2, 'btn-light': contrattoSelezionato.FK_ID_TIPO != 2 }"
                                        v-on:click="contrattoSelezionato.FK_ID_TIPO = 2">
                                        <i class="fas fa-gas-pump" v-bind:class="{ 'text-danger': contrattoSelezionato.FK_ID_TIPO == 2 }"></i>
                                        GAS
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- Sezione Tipologia Calcolo -->
                        <div class="btn-group" style="margin:0 auto" role="group" aria-label="Basic example">
                            <div class="col">
                                <div class="row">
                                    <label style="margin:0 auto">Tipologia Calcolo:</label>
                                </div>
                                <div class="row mt-2">
                                    <button style="width:182px;height:60px" type="button" class="btn btn-lg"
                                        v-on:click="contrattoSelezionato.FK_ID_CALCOLO_MODALITA_IMPORTO = 1"
                                        v-bind:class="{ 'btn-secondary': contrattoSelezionato.FK_ID_CALCOLO_MODALITA_IMPORTO == 1, 'btn-light': contrattoSelezionato.FK_ID_CALCOLO_MODALITA_IMPORTO != 1 }">
                                        <i class="fas fa-thumbtack"></i> FISSO
                                    </button>
                                    <button style="width:182px;height:60px" type="button" class="btn btn-lg"
                                        v-on:click="contrattoSelezionato.FK_ID_CALCOLO_MODALITA_IMPORTO = 2"
                                        v-bind:class="{ 'btn-secondary': contrattoSelezionato.FK_ID_CALCOLO_MODALITA_IMPORTO == 2, 'btn-light': contrattoSelezionato.FK_ID_CALCOLO_MODALITA_IMPORTO != 2 }">
                                        <i class="fas fa-chart-bar"></i> INDICIZZATO
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- Sezione Allegato -->
                        <div class="btn-group" style="margin:0 auto" role="group" aria-label="Basic example">
                            <div class="col">
                                <div class="row">
                                    <label style="margin:0 auto">Carica Allegato:</label>
                                </div>
                                <div class="row mt-2">
                                    <button v-show="contrattoSelezionato.URL == ''" style="width:180px;height:60px"
                                        :disabled="!contrattoSelezionato.ID_CONTRATTO > 0"
                                        type="button" class="btn btn-secondary" v-on:click="openPopUpUpload(contrattoSelezionato)">
                                        <i class="fas fa-file"></i> Carica Allegato
                                        <small>(nessun allegato presente)</small>
                                    </button>
                                    <button v-show="contrattoSelezionato.URL != ''" style="width:180px;height:60px"
                                        type="button" class="btn btn-danger" v-on:click="openPopUpUpload(contrattoSelezionato)">
                                        <i class="fas fa-file-pdf"></i> Allegato Caricato
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Form principale -->
                    <form>
                        <div class="row">
                            <div class="form-group col-12">
                                <div class="form-row">
                                    <div class="form-group col-md-3">
                                        <label>Cliente:</label>
                                        <Select2 :disabled="!clienteAbilitato" v-model="contrattoSelezionato.FK_ID_CLIENTE" :w="250"
                                            :api="'es/cliente/select2?a=1'" :apiselected="'es/cliente/s2'">
                                        </Select2>
                                    </div>
                                    <div v-show="contrattoSelezionato.FK_ID_TIPO == 1" class="form-group col-md-3">
                                        <label>Pod:</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="POD..." v-model="contrattoSelezionato.POD">
                                    </div>
                                    <div v-show="contrattoSelezionato.FK_ID_TIPO == 2" class="form-group col-md-3">
                                        <label>Pdr:</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="PDR..." v-model="contrattoSelezionato.PDR">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Codice Cliente:</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="Numero Cliente..." v-model="contrattoSelezionato.CODICE_CLIENTE">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Codice Contratto:</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="Numero Contratto..." v-model="contrattoSelezionato.NUMERO_CONTRATTO">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Prezzo fisso:</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="Prezzo Fisso..." v-model="contrattoSelezionato.PREZZO_FISSO">
                                    </div>
                                </div>
                                <!-- Altri campi -->
                                <div class="form-row">
                                    <div class="form-group col-md-2">
                                        <label>Quota Comm:</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="Quota Comm..." v-model="contrattoSelezionato.QUOTA_COMM">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Spread:</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="Spread..." v-model="contrattoSelezionato.SPREAD">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Fornitore:</label>
                                        <select class="form-control form-control-sm" v-model="contrattoSelezionato.FK_ID_FORNITORE">
                                            <option value= 0>Nessuno</option>
                                            <option v-for="fornitore in this.arrayFornitori" v-bind:value="fornitore.ID_FORNITORE" v-bind:key="fornitore.ID_FORNITORE">
                                                {{ fornitore.DENOMINAZIONE_FORNITORE }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>Comune Fornitura:</label>
                                        <Select2 v-model="contrattoSelezionato.FK_ID_COMUNE_FORNITURA" :w="250"
                                            :api="'core/geo/comuni/select2'" :apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'">
                                        </Select2>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>Indirizzo Fornitura</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="Indirizzo Fornitura..." v-model="contrattoSelezionato.INDIRIZZO_FORNITURA">
                                    </div>
                                </div>
                                <!-- Ultimi campi -->
                                <div class="form-row">
                                    <div class="form-group col-md-3">
                                        <label>Metodo Pagamento:</label>
                                        <select class="form-control form-control-sm" v-model="contrattoSelezionato.FK_ID_MODALITA_PAGAMENTO">
                                            <option v-for="metodo in this.arrayMetodiPagamenti" v-bind:value="metodo.ID_MODALITA_PAGAMENTO" v-bind:key="metodo.ID_MODALITA_PAGAMENTO">
                                                {{ metodo.DESCRIZIONE }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>Descrizione Offerta:</label>
                                        <input type="text" class="form-control form-control-sm" placeholder="Descrizione Offerta..." v-model="contrattoSelezionato.DESCRIZIONE_OFFERTA">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Data Attivazione:</label>
                                        <DatePicker placeholder="data attivazione..." autocomplete="off" :dim="'sm'" type="text" v-model="contrattoSelezionato.DATA_ATTIVAZIONE"></DatePicker>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Data Scadenza:</label>
                                        <DatePicker placeholder="data scadenza..." autocomplete="off" :dim="'sm'" type="text" v-model="contrattoSelezionato.DATA_SCADENZA"></DatePicker>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Scadenzario:</label>
                                        <button :disabled="contrattoSelezionato.FK_ID_CLIENTE > 0 && contrattoSelezionato.creazione != 0"
                                            style="width: 170px;" class="btn btn-success btn-sm" v-on:click="openPopUpScadenzario(contrattoSelezionato)">
                                            <i class="fal fa-plus"></i> Scadenza
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button :disabled="contrattoSelezionato.FK_ID_FORNITORE == 0" :title="contrattoSelezionato.FK_ID_FORNITORE == 0 ? 'Selezionare il fornitore per abilitare il salvataggio' : ''" class="btn btn-success float-right" v-on:click="salvaContratto()">
                        <i class="fa fa-check"></i> Salva
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- PopUp Upload Responsivo -->
    <div class="modal fade" id="popUpUpload" data-backdrop="true" role="dialog" aria-modal="true">
        <div :class="{'modal-dialog modal-fullscreen': $root.isMobile, 'modal-dialog': !$root.isMobile}" :style="modalStyle">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background: #127787;">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-file-contract fa-fw"></i> Contratto</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" :style="bodyStyleUpload">
                    <div class="row">
                        <div class="col-6">
                            <Upload @onsuccess="successCaricamento($event)" @onerror="errorCaricamento()" :w="90" :args="args"></Upload>
                        </div>
                        <div class="col-6">
                            <div v-show="contrattoSelezionato.URL == ''" class="form-group col-md-12 shadow"
                                style="margin-bottom: 0.5rem; margin-top: 20px; text-align: center;padding: 16px;border: 1px solid #ccc;background-color: rgba(221, 221, 221,0,7);border-radius: 10px;height:294px">
                                <br>
                                <span>
                                    <h3>Allegato non ancora caricato</h3><br>
                                    <h4>Caricare solo File PDF</h4>
                                </span>
                            </div>
                            <div v-show="contrattoSelezionato.URL != ''" class="alert alert-danger"
                                style=" margin-bottom: 0.5rem; opacity: 10;margin-top: 20px; text-align: center;border: 6px solid #ccc;;border-radius: 10px;height:324px">
                                <br>
                                <i class="fas fa-file-pdf fa-4x"></i>
                                <span>
                                    <h3>Presente allegato per questo contratto</h3>Collegamento al documento qui:<br>
                                    <a v-if="contrattoSelezionato.URL != undefined" v-on:click="getPathDocumento()">
                                        {{ contrattoSelezionato.URL.toString().split('/')[contrattoSelezionato.URL.toString().split('/').length - 1]}}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" @click="salvaUpload()">
                        <i class="fa fa-check"></i> Salva
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- PopUp Scadenzario Responsivo -->
    <div class="modal fade" id="popUpScadenzario" data-backdrop="true" role="dialog" aria-modal="true">
        <div :class="{'modal-dialog modal-fullscreen': $root.isMobile, 'modal-dialog': !$root.isMobile}" :style="modalStyle">
            <div class="modal-content">
                <div class="modal-header modal-header-primary">
                    <h5 style="color:#fff;" class="modal-title"><i class="far fa-calendar-plus fa-fw"></i> Aggiungere Cliente allo Scadenzario?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" :style="bodyStyleUpload" style="height: 300px !important;">
                    <form>
                        <div class="form-row">
                            <div class="form-group  col-md-6">
                                <label>Data Scadenza:</label>
                                <DatePicker placeholder="data scadenza" autocomplete="off" :dim="'sm'" type="text" style="width:100%" v-model="scadenzaSelezionata.DATA_SCADENZA"></DatePicker>
                            </div>
                            <div class="form-group col-md-6" style="text-align: center;">
                                <div class="btn-group-vertical">
                                    <button style="border-top-left-radius: 15px;border-top-right-radius: 0px;" type="button" class="btn btn-secondary btn-sm" @click="modificaData(7)">-7W</button>
                                    <button style="border-bottom-left-radius: 15px; border-bottom-right-radius: 0px;" type="button" class="btn btn-secondary btn-sm" @click="modificaData(30)">-1M</button>
                                </div>
                                <div class="btn-group-vertical">
                                    <button style="border-top-right-radius: 15px;border-top-left-radius: 0px;" type="button" class="btn btn-secondary btn-sm" @click="modificaData(-7)">+7W</button>
                                    <button style="border-bottom-right-radius: 15px; border-bottom-left-radius: 0px;" type="button" class="btn btn-secondary btn-sm" @click="modificaData(-30)">+1M</button>
                                </div>
                            </div>
                            <div class="form-group col-md-12">
                                <label>Note:</label>
                                <textarea class="form-control form-control-sm" rows="8" placeholder="Inserisci le tue note qui..." v-model="scadenzaSelezionata.NOTE"></textarea>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger" data-dismiss="modal">Annulla</button>
                    <button class="btn btn-success" @click="vaiAvanti()">Vai Avanti</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

/* import Pagine from '@/components/utils/Pagine.vue' */
import DatePicker from '@/components/utils/DatePicker.vue'
import Select2 from '@/components/utils/Select2.vue'
import Upload from '@/components/utils/Upload.vue'


export default {
    name: "PopUpContratto",
    emits: ['contrattoSalvato'],
    components: {
        /*   Pagine, */
        DatePicker,
        Select2,
        Upload

    },
    data: function () {
        return {
            /*  filters:global.filters,
             search:{
                 PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
             }, */
            arrayFornitori: new Array(),
            arrayMetodiPagamenti: new Array(),
            contrattoSelezionato: {},
            scadenzaSelezionata: {},
            args: { modalita: "ES_uploadDoc" },
            clienteAbilitato: false,
            dataModificata: '',
            scadenzaAggiunta: false
        }
    },
    methods: {
       
        getContratti: function () {
            global.utils.get('/es/contratti', {}, (response) => {
                this.arrayContratti = response.data;
            });
        },
        getContratto: function (contratto) {
            global.utils.get('/es/contratto', { ID_CONTRATTO: contratto.ID_CONTRATTO }, (response) => {
                this.contrattoSelezionato = utils.clone(response.data);

            })
        },
        successCaricamento: function (response) {
            utils.alert.success("Operazione correttamente eseguita");
            if (response.esito == 0) {
                this.contrattoSelezionato.URL = response.data.URL;
                utils.closeModal('popUpUpload')
            }
            //this.getContratto(this.contrattoSelezionato);

        },
        errorCaricamento: function () {
            utils.alert.warning("Formato Non Valido, inserire solo file PDF")
        },
        salvaContratto: function () {
            //update
            if (this.contrattoSelezionato.ID_CONTRATTO > 0) {
                global.utils.put('/es/contratto', this.contrattoSelezionato, (response) => {
                    if (response.esito == 0) {
                        this.$emit('contrattoSalvato')
                        utils.alert.success(response.messaggio);
                        utils.closeModal('popUpContratto')
                    }

                });
            } else {
                //insert
                global.utils.post('/es/contratto', this.contrattoSelezionato, (response) => {
                    if (response.esito == 0) {
                        this.$emit('contrattoSalvato')
                        if (this.scadenzaSelezionata.DATA_SCADENZA != undefined) {
                        global.utils.post('/es/scadenza', this.scadenzaSelezionata, (res) => {
                            if (res.esito === 0) {
                                utils.alert.success("Scadenza salvata con successo");
                            }
                        });
                    }

                    utils.closeModal('popUpContratto');
                    }

                });
            }
        },
        salvaScadenza: function () {

            if (this.contrattoSelezionato.ID_CONTRATTO > 0) {
                global.utils.put('/es/scadenza', this.scadenzaSelezionata, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        utils.closeModal('popUpScadenzario')
                    }
                });
            } else {
                global.utils.post('/es/scadenza', this.scadenzaSelezionata, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        utils.closeModal('popUpContratto');
                    }
                });
            }
        },

        modificaData: function (giorniDaSottrarre) {
            let data = new Date(filters.formatDateReverse(this.scadenzaSelezionata.DATA_SCADENZA))
            data.setDate(data.getDate() - giorniDaSottrarre)
            this.scadenzaSelezionata.DATA_SCADENZA = filters.formatDate(data.toISOString().split('T')[0])
        },
        vaiAvanti() {
            if (!this.scadenzaSelezionata.FK_ID_CLIENTE) {
                this.scadenzaSelezionata.FK_ID_CLIENTE = this.contrattoSelezionato.FK_ID_CLIENTE;
            }
            this.scadenzaAggiunta = true;
            utils.closeModal('popUpScadenzario');
        },
        openSchedaContratto: function (contratto, _clienteAbilitato) {
            this.clienteAbilitato = _clienteAbilitato;
            if (contratto.ID_CONTRATTO > 0) {
                this.args.ID_CONTRATTO = contratto.ID_CONTRATTO;
                this.getContratto(contratto)
                utils.openModal('popUpContratto')
            }
            else {
                this.args.URL = ''
                this.args.ID_CONTRATTO = 0
                this.contrattoSelezionato = { ID_CONTRATTO: 0, FK_ID_CLIENTE: contratto.FK_ID_CLIENTE, URL: '', creazione: 0, FK_ID_FORNITORE : 0 }
                utils.openModal('popUpContratto')

            }
        },
        openPopUpUpload: function (contratto) {
            var modal = utils.openModal('popUpUpload')
        },
        openPopUpScadenzario: function (contratto) {
            this.scadenzaSelezionata = {
                FK_ID_CLIENTE: contratto.FK_ID_CLIENTE || this.contrattoSelezionato.FK_ID_CLIENTE,
                DATA_SCADENZA: contratto.DATA_SCADENZA,
                NOTE: "\nCodice Cliente: " + contratto.CODICE_CLIENTE +
                    "\nNumero Contratto: " + contratto.NUMERO_CONTRATTO +
                    "\nData Scadenza del Contratto: " + contratto.DATA_SCADENZA +
                    "\nDescrizione Offerta: " + contratto.DESCRIZIONE_OFFERTA
            }

            var modal = utils.openModal('popUpScadenzario')
        },

        getPathDocumento: function () {
            window.open(utils.BASE_API + 'es/contratto/upload?ID_CONTRATTO=' + this.contrattoSelezionato.ID_CONTRATTO, '_blank')
        },
    },
   /*  created: function () {
        //PRIMA FAI UNA GET FORNITORI CHE ALIMENTA UNA VARIABILE GLOBALE $arrayFornitori
        //NEL CALLBACK FAI LA GET CONTRATTI 
        global.utils.get('/es/fornitori', {}, (response) => {
            this.arrayFornitori = response.data;
        });
        global.utils.get('/es/pagamenti', {}, (response) => {
            this.arrayMetodiPagamenti = response.data;
        });

    }, */
    computed:{
         modalStyle() {
            return this.$root.isMobile ? { width: '100%', maxWidth: '100%' } : { minWidth: '1100px' };
        },
        bodyStyle() {
            return this.$root.isMobile ? { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' } : { height: '420px' };
        },
        bodyStyleUpload() {
            return this.$root.isMobile ? { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' } : { height: '460px' };
        },
    }
}
</script>
<style>
.btn-personalized {
    background-color: rgb(18, 119, 135);
}
#popUpScadenzario {
    z-index: 3000 !important;
}
@media (max-width: 768px) {
    .modal-fullscreen {
        width: 100%;
        max-width: 100%;
        height: 100%;
        margin: 0;
    }
}
</style>
